import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { searchCenterStore } from '@blade-sxp/search-center/store/searchCenter';
import colors from '@/styles/color.scss';
let Device = class Device extends Vue {
    dialogVisible = false;
    deviceId = '';
    trackData = {};
    index = 0;
    name = '';
    id;
    colors = colors;
    isHover = false;
    lineVertices = [];
    // 设备点显隐控制
    get isLineHover() {
        return searchCenterStore.isLineHover;
    }
    get selectId() {
        return searchCenterStore.selectId;
    }
    get selectNumber() {
        return searchCenterStore.selectNumber;
    }
    get mapUrl() {
        return searchCenterStore.mapUrl;
    }
    get firstNum() {
        return this.trackData.showIndex.split(',')[0];
    }
    get pointStyles() {
        return {
            borderRadius: this.trackData.zoneId === '0' ? '50%' : '0',
            background: this.selectNumber === Number(this.trackData.showIndex) && this.isHover ? colors.searchYellow : `${colors.white}`,
            width: (this.index === 0 && !this.isHover) || (this.index === this.lineVertices.length - 1 && !this.isHover)
                ? '12px'
                : this.isHover
                    ? '20px'
                    : '9px',
            height: (this.index === 0 && !this.isHover) || (this.index === this.lineVertices.length - 1 && !this.isHover)
                ? '12px'
                : this.isHover
                    ? '20px'
                    : '9px',
            opacity: this.lineVertices.length > 1 &&
                (this.index === 0 || this.index === this.lineVertices.length - 1 || this.selectNumber === this.index)
                ? 0
                : 1, // 有两个以上的点时起始点与当前选择点隐藏
        };
    }
    handleClick(item) {
        searchCenterStore.updateIsdevicedClick(true);
        if (item) {
            searchCenterStore.updateSelectNumber(Number(item));
        }
        else {
            searchCenterStore.updateSelectNumber(Number(this.trackData?.showIndex?.split(',')[0]));
        }
        // 点击进行线动画 并联动左侧列表高亮 记录设备id 高亮左侧列表
        searchCenterStore.updateAnimationDeviceId(this.deviceId);
        searchCenterStore.updateChoseIndex(this.index);
    }
    numClick(item) {
        this.handleClick(item);
    }
    onMouseenter() {
        this.isHover = true;
        this.$emit('deviceMouseEvent', 'enter', this.id);
    }
    onMouseleave() {
        this.isHover = false;
        setTimeout(() => {
            this.$emit('deviceMouseEvent', 'leave', this.id);
        }, 1000);
    }
};
Device = __decorate([
    Component({
        name: 'device',
    })
], Device);
export default Device;
